import { gql } from '@apollo/client';

const CREATE_SHIPMENT_ORDER = gql`
  mutation createShipmentOrder($input: CreateShipmentOrderInput!) {
    createShipmentOrder(input: $input) {
      isSuccess
      message
      shipmentOrder {
        rates {
          id
          carrier
          amount
          estimatedDays
          attributes
          serviceLevelName
        }
      }
    }
  }
`;

export default CREATE_SHIPMENT_ORDER;
